export const unauthorizedMiddleware = () => (next) => (action) => {

    if (action.payload?.status === 401) {
        window.location.href = "/"
        localStorage.removeItem("accessToken");
    }

    return next(action);
};